var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "box-card",
      attrs: {
        "body-style": { padding: "20px" },
        shadow: "never",
        bordered: false,
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "模型：", required: "" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "from-ipt-width",
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        placeholder: "请选择",
                      },
                      model: {
                        value: _vm.value.model,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "model", $$v)
                        },
                        expression: "value.model",
                      },
                    },
                    _vm._l(_vm.modelOptions, function (item, idx) {
                      return _c("el-option", {
                        key: idx,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标识：", required: "" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      placeholder: "请输入标识",
                      disabled: _vm.disabled || _vm.isAuto,
                    },
                    model: {
                      value: _vm.value.promptLabel,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "promptLabel",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.promptLabel",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "prompt词：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "460px" },
                    attrs: {
                      type: "textarea",
                      rows: 12,
                      placeholder: "请输入提示词",
                      disabled: _vm.disabled || _vm.isAuto,
                    },
                    model: {
                      value: _vm.value.promptContent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "promptContent",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.promptContent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "温度参数：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 2,
                      step: 0.01,
                      disabled: _vm.disabled,
                      "controls-position": "right",
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.value.temperature,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "temperature", $$v)
                      },
                      expression: "value.temperature",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "最大令牌数：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 1,
                      step: 1,
                      disabled: _vm.disabled,
                      "controls-position": "right",
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.value.maxTokens,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "maxTokens", $$v)
                      },
                      expression: "value.maxTokens",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "频率惩罚：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 2,
                      step: 0.01,
                      disabled: _vm.disabled,
                      "controls-position": "right",
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.value.frequencyPenalty,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "frequencyPenalty", $$v)
                      },
                      expression: "value.frequencyPenalty",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("减少重复内容"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "存在惩罚：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      max: 2,
                      step: 0.01,
                      disabled: _vm.disabled,
                      "controls-position": "right",
                      "step-strictly": "",
                    },
                    model: {
                      value: _vm.value.presencePenalty,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "presencePenalty", $$v)
                      },
                      expression: "value.presencePenalty",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v("减少重复内容"),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "中止词：" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "460px" },
                    attrs: {
                      type: "textarea",
                      rows: 5,
                      placeholder: "请输入中止词",
                      disabled: _vm.disabled,
                    },
                    model: {
                      value: _vm.value.stopWords,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "stopWords",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.stopWords",
                    },
                  }),
                  _c("div", { staticClass: "from-tips" }, [
                    _vm._v('最多输入4个中止词，两个之间以英文","分割'),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }